import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import * as Util from "../Utils/Util";
import Hider from "../Utils/Hider";
import ProductState from "./ProductState";

export default class SubscriptionFrequencySelection {
  private readonly element: HTMLElement;
  private readonly selectElement: HTMLSelectElement;
  private readonly productCode: string;
  private readonly strengthCode: string;

  public constructor(element: HTMLElement) {
    this.element = element;

    this.selectElement = element.querySelector("select")!;
    this.selectElement.addEventListener("change", (e) => this.handleSelection(e));

    this.productCode = Util.getData(element, "productCode");
    this.strengthCode = Util.getData(element, "strengthCode");

    Events.on("product-state-change", (s: ProductState) => this.handleChangedState(s));
  }

  private shouldShow(state: ProductState): boolean {
    return this.productCode == state.product.code && this.strengthCode == state.strength.code && !!state.frequency;
  }

  private handleChangedState(state: ProductState) {
    const shouldShow = this.shouldShow(state);
    Hider.match(this.element, shouldShow);

    if (shouldShow) {
      this.selectElement.value = state.frequency!.code;
    }
  }

  private handleSelection(event: Event) {
    const element: HTMLOptionElement = <HTMLOptionElement>event.target!;
    Events.fire("frequency-changed", element.value!);
  }

  public static Factory: DomFactory<SubscriptionFrequencySelection> = (e) => new SubscriptionFrequencySelection(e);
}
